import { useDocTitle } from 'util/hooks'

import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { AuthCard } from 'auth/auth-card'

export const Success = () => {
	const searchParams = useMemo(() => new URLSearchParams(window.location.search), [])
	const from = searchParams.get('from')

	// If user came from settings, they're logged in - go to dashboard
	// Otherwise, they need to log in with new password
	const redirectPath = from === 'settings' ? '/dashboard' : '/login'
	const buttonText = from === 'settings' ? 'Back to Dashboard' : 'Log in'

	useDocTitle('All for One - Success')

	return (
		<AuthCard
			eyebrow="All set"
			title="Success!"
			subtitle="You have successfully reset your password for your account."
		>
			<Link to={redirectPath} className="auth-btn auth-btn--last">{buttonText}</Link>
		</AuthCard>
	)
}
